module.exports = __webpack_public_path__ + "img/header-weddingRingsDiamonds.c23ff16.webp";